import React, { Component } from 'react';
import { Example, Properties, SourceCode, Tip } from 'examples';
import Application from '../Application/Application';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import Button from '../Button/Button';
import Header from './Header';
import Menu from '../Menu/Menu';

const callback = (type, cb) => { window.showAppInfo(type); Application.showDialog(`${type} clicked`, `The ${type} button is only visible if the ${cb} is set.`); };

// const PATH = ['Home', 'Level 1', 'Level 2', 'Level 3'];
const PATH = [{
  title: 'Home',
}, {
  title: 'Level 1',
}, {
  title: 'Level 2',
}, {
  title: 'Last',
}];

export default class HeaderExample extends Component {

  constructor(props) {
    super(props);
    this.state = {
      backgroundUrl: 'https://images.unsplash.com/photo-1472148083604-64f1084980b9?dpr=1&auto=compress,format&fit=crop&w=1199&h=799&q=80&cs=tinysrgb&crop=',
      badgeNames: ['lock', 'link'],
      tag: 'Draft',
      title: 'Curated Content',
    };
    this.onAdd = callback.bind(this, 'Add', 'onAdd');
    this.onClose = callback.bind(this, 'Close', 'onClose');
  }

  onChange = e => this.setState(e.target.value);

  onClickBreadcrumbs = e => window.showAppInfo(e.target.value.title);

  render() {
    const menu = (
      <Menu offset={15}>
        <Button>Item 1</Button>
        <Button>Item 2</Button>
      </Menu>
    );

    return (
      <Example {...this.props} className="header-examples">
        <Properties onChange={this.onChange} defaultProps={Header.defaultProps} propTypes={Header.propTypes} propValues={this.state}>
          <Tip>
            Try setting class name to <span className="string">archive</span>, <span className="string">history</span> or
            <span className="string">planned</span>.
          </Tip>
          <Tip>You can long press the <strong>Back</strong> button to display the entire navigation path.</Tip>
          <Tip>
            The <a href="/breadcrumbs"><code>Breadcrumb</code></a> component is a separate component and not part of this
            component, but it shows how you can add custom components to the <code>Header</code>.
          </Tip>
        </Properties>
        <Header {...this.state} menu={menu} onAdd={this.onAdd} onClose={this.onClose}>
          <Breadcrumbs path={PATH} onClick={this.onClickBreadcrumbs}/>
        </Header>
        <SourceCode querySelector=".header-examples .core-header"/>
      </Example>
    );
  }

}
